module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epi"
  }, [_c('i', [_vm._v("“Would you believe that I don’t like to think")])]), _vm._v(" "), _c('p', {
    staticClass: "inset"
  }, [_c('i', [_vm._v("back on those times, primarily")])]), _vm._v(" "), _c('p', {
    staticClass: "inset"
  }, [_c('i', [_vm._v("because then I feel really sad, ")])]), _vm._v(" "), _c('p', {
    staticClass: "inset"
  }, [_c('i', [_vm._v("really feel it, deep down?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }), _vm._v(" "), _c('p', {
    staticClass: "inset"
  }, [_c('i', [_vm._v("How can I answer her, who answered me")])]), _vm._v(" "), _c('p', {
    staticClass: "inset"
  }, [_c('i', [_vm._v("So many ways,")])]), _vm._v(" "), _c('p', {
    staticClass: "inset"
  }, [_c('i', [_vm._v("Whom now the same precocious spring betrays?")])]), _vm._v(" "), _c('p', {
    staticClass: "inset"
  }, [_c('i', [_vm._v("Say that time passes only to return?")])]), _vm._v(" "), _c('p', {
    staticClass: "inset"
  }, [_c('i', [_vm._v("Or utter that belated fiction that ")])]), _vm._v(" "), _c('p', {
    staticClass: "inset"
  }, [_c('i', [_vm._v("Time saddens, true, but also makes us wise?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }), _vm._v(" "), _c('p', {
    staticClass: "inset"
  }, [_vm._v("—Wayne Brown, “A Letter from Elizabeth,” ")]), _vm._v(" "), _c('p', {
    staticClass: "inset"
  }, [_c('i', [_vm._v("On the Coast and Other Poems")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8fe8f64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/epi.vue
// module id = 72
// module chunks = 0